module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-testimonial-2.fc2217f5.webp";